// src/redux/api/transactionApi.js
import { withDefaultMeta } from "../../util/withDefaultMeta";
import { apiSlice } from "../../app/apiSlice";

export const subscribersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const mutation = withDefaultMeta(builder.mutation);

    return {
      subscriber: mutation({
        query: (data) => ({
          url: "/subscribers",
          method: "POST",
          body: data,
        }),
        meta: { requiresAuth: false },
      }),

      // New endpoint for unsubscribing
      unsubscribe: mutation({
        query: (email) => ({
          url: `/subscribers/${email}`,
          method: "DELETE",
        }),
        meta: { requiresAuth: false },
      }),
    };
  },
});

export const { useSubscriberMutation, useUnsubscribeMutation } =
  subscribersApiSlice;
